import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import CardTypeInput from "../../../components/CardTypeInput";
import HeaderBread from "../../../components/HeaderBread";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import { getCardType } from "../../../utils/ApiCalls/CardTypes";

const EditCardType = () => {
  const params = useParams();
  const [cardtype, setCardType] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Card Type",
      route: "/website/loyalty/card-types",
    },
    {
      title: "Edit Card Type",
      route: "/website/loyalty/card-type/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getCardType({ id: value });

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.count === 1) {
      setCardType(data.data[0]);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"Card Type"}>
       <CustomHeaderTitle title={"Edit Card Type"}/>
      <HeaderBread
        navigation={navigation}
        title={"Edit Card Type"}
      ></HeaderBread>
      {cardtype && <CardTypeInput cardtype={cardtype} />}
    </Layout>
  );
};

export default EditCardType;
